import { render, staticRenderFns } from "./shift-request-modal.vue?vue&type=template&id=4b9aa34b&lang=pug"
import script from "./shift-request-modal.vue?vue&type=script&lang=ts"
export * from "./shift-request-modal.vue?vue&type=script&lang=ts"
import style0 from "./shift-request-modal.vue?vue&type=style&index=0&id=4b9aa34b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports